export class MeasureContext {
  locationConfirmed: boolean = false;
  registered: boolean = false;

  constructor() {
  }

  setLocationConfirmed(locationConfirmed: boolean): MeasureContext {
    this.locationConfirmed = locationConfirmed;
    return this;
  }

  setRegistered(registered: boolean): MeasureContext {
    this.registered = registered;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/measure-context.ts